<template>
    <button
        v-tippy="t('editorToggleTextAlignLeft')"
        :class="[
            buttonState(true, editor.isActive({ textAlign: 'left' })),
            'flex-none rounded p-1 text-sm',
        ]"
        @click="editor.chain().focus().setTextAlign('left').run()"
    >
        <MdiFormatAlignLeft class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatAlignLeft from 'materialdesignicons-vue3/icons/MdiFormatAlignLeft.js';

    defineExpose({
        name: 'TextAlignLeftButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
